import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Preloader } from '@/components/Preloader';
import { prettyDate, prettyFloatMoney } from '@/helpers/utils';
import { EMPTY_DASH } from '@/helpers/constants';
import { EmptyContent } from '../../components/EmptyContent';
import { StreakStatus } from '../../components/StreakStatus';
import s from './index.module.scss';

export const Table = ({ data, isLoading }) => {
  const { t } = useTranslation('streak');
  return (
    <div className={s.table_wrapper}>
      <div className={s.table_inner}>
        <div className={s.table}>
          <div className={s.table__thead}>
            <div
              className={s.table__thead_col}
              title={t('activity_table.round')}
            >
              {t('activity_table.round')}
            </div>
            <div
              className={s.table__thead_col}
              title={t('activity_table.topped_up')}
            >
              {t('activity_table.topped_up')}
            </div>
            <div
              className={s.table__thead_col}
              title={t('activity_table.withdrawn')}
            >
              {t('activity_table.withdrawn')}
            </div>
            <div
              className={s.table__thead_col}
              title={t('activity_table.net_cash_flow')}
            >
              {t('activity_table.net_cash_flow')}
            </div>
            <div
              className={s.table__thead_col}
              title={t('activity_table.round_status')}
            >
              {t('activity_table.round_status')}
            </div>
            <div
              className={s.table__thead_col}
              title={t('activity_table.income_increase')}
            >
              {t('activity_table.income_increase')}
            </div>
            <div
              className={s.table__thead_col}
              title={t('activity_table.net_cash_flow_bonus')}
            >
              {t('activity_table.net_cash_flow_bonus')}
            </div>
          </div>
          {isLoading ? (
            <Preloader className={s.preloader} />
          ) : data?.total_count > 0 ? (
            <div className={s.table__tbody}>
              {Object.keys(data.grouped)
                .reverse()
                .map(year => (
                  <div key={year}>
                    <div className={classnames(s.year, 'f-article-accent')}>
                      {year}
                    </div>
                    {data.grouped[year].map((item, index) => (
                      <div key={index} className={s.table__tbody_row}>
                        <div className={s.table__tbody_col}>
                          {prettyDate(item.round_date, 'MMMM')}
                        </div>
                        <div className={s.table__tbody_col}>
                          {prettyFloatMoney(item.topped_up, {
                            decimalPlaces: 2,
                          })}
                        </div>
                        <div className={s.table__tbody_col}>
                          {prettyFloatMoney(item.withdrawn, {
                            decimalPlaces: 2,
                          })}
                        </div>
                        <div className={s.table__tbody_col}>
                          {prettyFloatMoney(item.net_cash_flow, {
                            decimalPlaces: 2,
                          })}
                        </div>
                        <div className={s.table__tbody_col}>
                          <StreakStatus status={item.round_status} />
                        </div>
                        <div className={s.table__tbody_col}>
                          {Number(item.income_increase)
                            ? `+${item.income_increase}%`
                            : EMPTY_DASH}
                        </div>
                        <div className={s.table__tbody_col}>
                          {Number(item.net_cash_flow_bonus)
                            ? prettyFloatMoney(item.net_cash_flow_bonus, {
                                decimalPlaces: 2,
                              })
                            : EMPTY_DASH}
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
            </div>
          ) : (
            <div className={s.empty}>
              <EmptyContent />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
